import { Transaction } from "../../types/budgethelper";

export interface NetBalance {
  userId: string;
  balance: number;
  isOwed: boolean;
}

export interface SettlementData {
  netBalances: NetBalance[];
  selectedGroupId: string;
}

export function calculateBalancesForGroup(
  filteredTransactions: Transaction[],
  selectedGroupId: string
): SettlementData {
  const balances: { [userId: string]: number } = {};
  
  // Process each transaction
  filteredTransactions.forEach((transaction) => {
    if (transaction.budgetGroup !== selectedGroupId) return;
    
    const paidByUser = transaction.paidBy || transaction.userId;
    const splitAmounts = transaction.splitAmounts || { [paidByUser]: transaction.amount };
    
    // The person who paid gets credited
    balances[paidByUser] = (balances[paidByUser] || 0) + transaction.amount;
    
    // Each person who owes gets debited
    Object.entries(splitAmounts).forEach(([userId, amount]) => {
      const numAmount = typeof amount === 'string' ? parseFloat(amount) || 0 : amount;
      balances[userId] = (balances[userId] || 0) - numAmount;
    });
  });
  
  // Convert to array and filter out near-zero balances
  const netBalances = Object.entries(balances)
    .filter(([_, balance]) => Math.abs(balance) > 0.01)
    .map(([userId, balance]) => ({ 
      userId, 
      balance: parseFloat(balance.toFixed(2)),
      isOwed: balance > 0
    }))
    .sort((a, b) => b.balance - a.balance);
  
  return { netBalances, selectedGroupId };
}
